import { Market, SportMatchModel } from '@nf/types/odds';
import { useEffect, useState } from 'react';
import { useUpdateMatch } from './use-update-match';
import { IO, MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { oddsApiService } from '@nf/odds/services';
import { orderMarkets } from '@/utils/odds-utils';
import { useSiteStore } from '@/store/site';

interface UseMatchBetTypesProps {
    match: SportMatchModel;
    isFetchFromGetMarket: boolean;
    sportId: number;
    betTypeClass: string
}

export const useMatchBetTypes = ({
	match,
	isFetchFromGetMarket,
	sportId,
	betTypeClass,
}: UseMatchBetTypesProps) => {
	const [finalMarkets, setFinalMarkets] = useState<Market[]>(match.BetTypes);
	const [hasGetMarket, setHasGetMarket] = useState<boolean>(false);
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	const onUpdateMatch = (markets: Market[]) => {
		!hasGetMarket && setHasGetMarket(true);
		IO.of(markets)
			.map(mergeMarkets([...match.BetTypes]))
			.map(orderMarkets)
			.map(setFinalMarkets)
			.run();
	}
	useUpdateMatch(match.MatchId, onUpdateMatch);

	useEffect(() => {
		// using new odds from update odds
		IO.of([...match.BetTypes])
			.map(orderMarkets)
			.map(setFinalMarkets)
			.run();
	}, [match.BetTypes])

	useEffect(() => {
		MaybeMatch(isFetchFromGetMarket)
			.chain(() => MaybeMatch(!hasGetMarket))
			.fold(
				() => {},
				() => oddsApiService.matchApi.getMatchMarkets({
					sport: sportId,
					market: sportId === 999 ? 't' : match.MaT,
					betTypeClass: isParlayMode ? 'parlay' : betTypeClass,
					matchId: match.MatchId
				})
			)
	}, [isFetchFromGetMarket, isParlayMode])

	return {
		markets: [...finalMarkets],
		hasGetMarket
	};
}

const mergeMarkets = (sourceMarkets: Market[]) => (newMarkets: Market[]) => {
	newMarkets.forEach(newMarket => {
		const index = sourceMarkets.findIndex(market => market.MarketId === newMarket.MarketId);
		if (index > -1) {
			sourceMarkets[index] = newMarket;
			return;
		}
		sourceMarkets.push(newMarket);
	});
	return sourceMarkets;
}